module.exports = __webpack_public_path__ + "dbab5d8c4961be6075d6664cd505a69d.png";